export default __webpack_public_path__ + "static/ivan-kyvatskyi-32c12a6eba0fe26336ff4b0d09ea9c14.jpeg";